module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("LOST IN SPACE")])], 1), _vm._v(" "), _c('nav', {
    staticClass: "row navbar"
  }, [(_vm.userLoggedIn) ? _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e(), _vm._v(" "), (!_vm.userLoggedIn) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.userLoggedIn) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/account"
    }
  }, [_vm._v("Account")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/galaxy"
    }
  }, [_vm._v("Galaxy")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/todo"
    }
  }, [_vm._v("To-Do")]), _vm._v(" "), (_vm.userLoggedIn) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/email"
    }
  }, [_vm._v("Email")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://api.omnomzom.com/rss.php"
    }
  }, [_vm._v("RSS")])], 1), _vm._v(" "), _c('hr', {
    staticClass: "navbar-seperator",
    attrs: {
      "id": "content-top"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-843835ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 281
// module chunks = 1